/* EU-Pflichthinweis gesetzliche Gewaehrleistung – oeffnet/schliesst #gwh-dialog.
   Event-Delegation am document, damit auch per Section-Rendering neu gezeichnete Trigger (Cart-Drawer) funktionieren. */
(function () {
  if (window.__gwhInit) return;
  window.__gwhInit = true;

  var lastTrigger = null;

  function getDialog() {
    return document.getElementById('gwh-dialog');
  }

  function openDialog(trigger) {
    var dialog = getDialog();
    if (!dialog || dialog.open) return;
    lastTrigger = trigger;
    // Bild ist lazy (kein Ballast beim Seitenaufruf); beim Oeffnen sofort laden
    var image = dialog.querySelector('img[loading="lazy"]');
    if (image) image.loading = 'eager';
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('gwh-scroll-lock');
    var panel = dialog.querySelector('.gwh-panel');
    if (panel) panel.scrollTop = 0;
  }

  function closeDialog() {
    var dialog = getDialog();
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      onClosed();
    }
  }

  function onClosed() {
    document.documentElement.classList.remove('gwh-scroll-lock');
    var target = lastTrigger;
    lastTrigger = null;
    // Trigger kann durch Section-Rendering ersetzt worden sein -> Fallback auf ersten sichtbaren Trigger
    if (!target || !target.isConnected) {
      target = document.querySelector('[data-gwh-open]');
    }
    if (target && typeof target.focus === 'function') target.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-gwh-open]');
    if (opener) {
      event.preventDefault();
      openDialog(opener);
      return;
    }

    var dialog = getDialog();
    if (!dialog || !dialog.open) return;

    if (event.target.closest && event.target.closest('[data-gwh-close]')) {
      closeDialog();
      return;
    }

    // Klick auf den Backdrop landet direkt auf dem <dialog>-Element (Panel fuellt den Inhalt)
    if (event.target === dialog) closeDialog();
  });

  // ESC selbst abfangen (Capture auf window, vor den Theme-Listenern): Der Cart-Drawer schliesst sonst auf ESC
  // und verhindert per preventDefault das native Schliessen des Dialogs. So schliesst ESC nur den Hinweis.
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var dialog = getDialog();
    if (!dialog || !dialog.open) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeDialog();
  }, true);

  // 'close' feuert bei jedem Schliessen (ESC, close()).
  document.addEventListener('close', function (event) {
    if (event.target && event.target.id === 'gwh-dialog') onClosed();
  }, true);
})();
